import { useContext } from 'react';
import { constants } from '../../testHelpers/fixtures';
import AssetContext from '../common/AssetContext';

export default () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useContext(AssetContext) as typeof constants['assets'] & {
    stripePublishableKey: string;
  };
